import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { useRefetchForStaleData } from 'hooks/useRefetchForStaleData';
import i18n, { loadTranslations } from 'i18n';
import { guestPortalIdSelector } from 'store/app/selectors';
import { setItinerariesItemDataAction } from 'store/itinerariesItem';
import { itineraryWithoutEmptyPagesSelector } from 'store/itinerariesItem/selectors';
import { accountIdSelector } from 'store/user/selectors';
import axios from 'utils/axios';
import { ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP } from 'utils/itineraries/functions';
import { checkIsWebviewReady } from 'utils/mobileApplication';

import { getLandingForViewMode } from '../../PropertyPortal/functions';

const map = {
  'guest-portal': ITINERARIES_ITEM_TYPES.GUEST_PORTAL,
  itinerary: ITINERARIES_ITEM_TYPES.ITINERARY,
};

export function useLoader() {
  const dispatch = useDispatch();
  const data = useSelector(itineraryWithoutEmptyPagesSelector);
  const accountId = useSelector(accountIdSelector);
  const { itemType: pathSegmentItemType, itemId } = useParams();
  const guestPortalId = useSelector(guestPortalIdSelector);
  const itinerariesItemType = map[pathSegmentItemType];

  const { isLoading, error, refetch } = useQuery(
    ['guest_portal', guestPortalId, itinerariesItemType],
    async () => {
      const url = `/acc/${accountId}/${ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType]}/${itemId}`;
      const { data } = await axios.get(url, {
        params: {
          client_facing: true,
        },
      });
      await loadTranslations(i18n, data?.settings?.language);

      const processedData = getLandingForViewMode(data, {
        alwaysHideImageBlocks: localStorage.getItem('pdfPreview') === 'true',
      });

      dispatch(setItinerariesItemDataAction(processedData));
      checkIsWebviewReady();

      return data;
    },
    {
      refetchOnWindowFocus: true,
    },
  );

  useRefetchForStaleData(refetch);

  return {
    data,
    isLoading,
    error,
    itinerariesItemType,
    accountId,
    guestPortalId,
    refetch,
  };
}
